"use client"

import type { FunctionComponent, HTMLAttributes, PropsWithChildren } from "react"

import { clsx } from "clsx"
import { usePathname } from "next/navigation"

import { isFeaturePage, isHome } from "@/modules/routing/helpers/isPage"

import styles from "./Header.module.css"

type InteractiveAppHeaderProps = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    isBannerVisible?: boolean
    isCareerCenter?: boolean
    isLogged?: boolean
  }>

export const InteractiveAppHeader: FunctionComponent<InteractiveAppHeaderProps> = ({
  children,
  className,
  isBannerVisible,
  isCareerCenter,
  isLogged,
}) => {
  const pathname = usePathname()
  const isHomepage = isHome(pathname)
  const isAnonymous =
    !isLogged &&
    !isCareerCenter &&
    !(
      isFeaturePage(pathname, "profiles/new") ||
      isFeaturePage(pathname, "users/confirmation/new") ||
      isFeaturePage(pathname, "account_setups/new")
    )

  return (
    <header
      className={clsx(className, {
        [styles.main__fixed]: isHomepage && !isBannerVisible,
        [styles["header--anonymousUser"]]: isAnonymous,
      })}
      role="banner"
    >
      {children}
    </header>
  )
}
